import React from "react";
import { TableHead as MUITableHead, TableRow, TableCell } from "@material-ui/core";

function TableHead({instance}) {
    const {
        headerGroups,
    } = instance;

    return(
        <MUITableHead>
            {headerGroups.map(headerGroup => (
                <TableRow {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                        <TableCell {...column.getHeaderProps()}>
                            {column.render('Header')}
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </MUITableHead>
    );
}

export default TableHead;
